import { isAcceptedImageSearchMimeType } from '~/utils/imageSearch';

export type VisualSearchDataTransferLook = {
  items: ArrayLike<{ kind: string; type: string }>;
  types: readonly string[];
};

export const canUseDataTransferForVisualSearch = (dataTransfer: VisualSearchDataTransferLook | undefined): boolean => {
  if (!dataTransfer) {
    return false;
  }

  const fileItems = Array.from(dataTransfer.items).filter((item) => item.kind === 'file');

  // On dragover, some browsers leave `items` empty and only advertise files via `types`.
  if (fileItems.length === 0) {
    return dataTransfer.types.includes('Files');
  }

  if (fileItems.length !== 1) {
    return false;
  }

  const mimeType = fileItems[0].type;

  if (!mimeType) {
    return true;
  }

  return isAcceptedImageSearchMimeType(mimeType);
};
